<button
  (click)="addDateBefore($event)"
  class="btn btn-soft-primary btn-sm"
  type="button"
>
  <i
    role="img"
    class="fa fa-plus me-lg-2"
    attr.aria-label="{{ 'general.add' | translate }}"
  ></i>
  <span class="d-none d-lg-inline"> {{ text }}</span>
</button>
